import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { BrandsService } from 'src/app/services/brands.service';
import { TagsService } from 'src/app/services/tags.service';
import { Brands, DataForBrandsPage, ImpactData } from 'src/app/shared/brands.model';
import { RouterUrls } from 'src/app/shared/router-urls';

import { LanguageService } from '../../services/language.service';
import { Constants } from '../../app.constants';

@Component({
  selector: 'app-brands-page',
  templateUrl: './brands-page.component.html',
  styleUrls: ['./brands-page.component.scss']
})
export class BrandsPageComponent implements OnInit {

  RouterUrls: RouterUrls;
  brands: Brands[];
  brandsSubscription: Subscription;
  clickEventSubscription: Subscription;
  impactData: ImpactData;
  isLoading = true;
  isMobile = false;

  constructor(
    private router: Router,
    private languageService: LanguageService,
    private brandsService: BrandsService,
    private meta: Meta,
    private tagsService: TagsService,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService) {
      this.clickEventSubscription = this.tagsService.getClickEventBrands().subscribe(() => {
        this.updateTags();
      });
    this.brandsService.getBrandsPageInfo().subscribe({
      next: (data: DataForBrandsPage) => {
        this.impactData = data.impact;
        // Shuffle companies using Fisher-Yates shuffle, fastest for small datasets
        this.brands = data.companies.sort(() => Math.random() - 0.5);
        this.updateTags();
        this.isLoading = false;
      },
      error: (error) => {
        this.router.navigate([this.languageService.getCurrentLangWithSlash()]);
        console.error(error);
      }
    });
  }

  get currentLanguage() {
    return this.languageService.getUserUsedLanguage();
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth < 1200;
    this.updateTags();
  }

  openBrandPage(slug: string) {
    this.router.navigate([
      this.languageService.getCurrentLangWithSlash(), RouterUrls.Brands, slug]);
  }

  updateTags() {
    this.titleService.setTitle(this.translate.instant('BRANDS_PAGE.meta_title_brandspage'));
    this.meta.updateTag({
      name: 'description',
      content: this.translate.instant('BRANDS_PAGE.meta_description_brandspage')
    });
    this.meta.updateTag({property: 'og:title', content: this.translate.instant('BRANDS_PAGE.meta_title_brandspage')});
    this.meta.updateTag({
      property: 'og:description',
      content: this.translate.instant('BRANDS_PAGE.meta_description_brandspage')
    });
    this.meta.updateTag({property: 'og:type', content: 'URL'});
    this.meta.updateTag({property: 'og:url', content: window.location.href});
    this.meta.updateTag({
      property: 'og:image',
      content: Constants.APP_URL + 'assets/backgrounds/bg-brands.webp'
    });
  }

  goToDemoPage(): void {
    switch (this.currentLanguage) {
      case Constants.FR_LANG_KEY:
        window.open(Constants.DEMO_LINK_FR, '_blank');
        break;
      case Constants.EN_LANG_KEY:
        window.open(Constants.DEMO_LINK_EN, '_blank');
        break;
      case Constants.ES_LANG_KEY:
        window.open(Constants.DEMO_LINK_ES, '_blank');
        break;
    }
  }

  OnDestroy(): void {
    this.brandsSubscription.unsubscribe();
  }
}
